import styled from "styled-components";

export const ErrorLabel = styled.p`
  font-size: 14px;
  color: red;
`;